import styled from "styled-components";

export const StyledFilteredDecisionSliderHeader = styled.div`
	padding: 2rem 1rem;

	display: flex;
	align-items: center;
	justify-content: flex-start;

	h4 {
		font-size: 1.6rem;
		font-weight: 700;
	}

	.checkbox-container {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.checkboxFilter {
		margin-left: 1.4rem;

		display: flex;
		align-items: center;
		justify-content: flex-start;

		& > span {
			margin-left: 0.75rem;

			cursor: pointer;

			&::selection {
				background-color: transparent;
			}
		}
	}
`;
